import * as styles from '@core/components/ImageViewer/ImageViewer.css';
import { IconButton, IconButtonSize, Eye, StatusCircleBlock, IconSize } from '@soteria/design-system-ve';

export interface DialogTitleWithButtonProps {
  title?: string;
  isBlurred: boolean;
  onToggleBlur: () => void;
}

/**
 * Title with inline blur toggle button
 */
export function DialogTitleWithButton({ title, isBlurred, onToggleBlur }: DialogTitleWithButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggleBlur();
  };

  return (
    <div className={styles.titleContainer}>
      <span>{title}</span>
      <IconButton
        aria-label={isBlurred ? 'Show content' : 'Hide content'}
        buttonSize={IconButtonSize.Small}
        icon={isBlurred ? Eye : StatusCircleBlock}
        iconSize={IconSize.Small}
        title={isBlurred ? 'Show content' : 'Hide content'}
        onClick={handleClick}
      />
    </div>
  );
}
